import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Informasi Umum Sekolah")
], -1)
const _hoisted_6 = { class: "row mb-6" }
const _hoisted_7 = { class: "col-lg-6 fv-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Sekolah", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Sekolah", -1)
const _hoisted_10 = ["label", "value"]
const _hoisted_11 = { class: "col-lg-6 fv-row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Kelas", -1)
const _hoisted_13 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "row mb-6" }
const _hoisted_17 = { class: "col-lg-6 fv-row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Kelas Detail", -1)
const _hoisted_19 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "col-lg-6 fv-row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Nomor Identitas", -1)
const _hoisted_24 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Biodata Siswa")
], -1)
const _hoisted_28 = { class: "row mb-6" }
const _hoisted_29 = { class: "col-lg-6 fv-row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Nama", -1)
const _hoisted_31 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_32 = { class: "fv-help-block" }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "col-lg-6 fv-row" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Jenis Kelamin", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Jenis Kelamin", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("option", {
  value: "MALE",
  key: "MALE"
}, "Laki-Laki", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("option", {
  value: "FEMALE",
  key: "FEMALE"
}, "Perempuan", -1)
const _hoisted_39 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "row mb-6" }
const _hoisted_43 = { class: "col-lg-6 fv-row" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Tanggal Lahir", -1)
const _hoisted_45 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_46 = { class: "fv-help-block" }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { class: "col-lg-6 fv-row" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Tempat Lahir", -1)
const _hoisted_50 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_51 = { class: "fv-help-block" }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { class: "row mb-6" }
const _hoisted_54 = { class: "col-lg-6 fv-row" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Provinsi", -1)
const _hoisted_56 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_57 = { class: "fv-help-block" }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { class: "col-lg-6 fv-row" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Kota/ Kabupaten", -1)
const _hoisted_61 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_62 = { class: "fv-help-block" }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { class: "row mb-6" }
const _hoisted_65 = { class: "col-lg-6 fv-row" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Kecamatan", -1)
const _hoisted_67 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_68 = { class: "fv-help-block" }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = { class: "col-lg-6 fv-row" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Alamat", -1)
const _hoisted_72 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_73 = { class: "fv-help-block" }
const _hoisted_74 = { key: 1 }
const _hoisted_75 = { class: "row mb-6" }
const _hoisted_76 = { class: "col-lg-6 fv-row" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Tag", -1)
const _hoisted_78 = { class: "fv-plugins-message-container" }
const _hoisted_79 = { class: "fv-help-block" }
const _hoisted_80 = { class: "card-footer d-flex justify-content-end py-6 px-9" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          id: "kt_account_profile_details_form",
          class: "form",
          disabled: "",
          novalidate: "novalidate",
          onSubmit: _cache[18] || (_cache[18] = ($event: any) => (_ctx.saveChanges1()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_Field, {
                    as: "select",
                    class: "form-select form-select-lg fw-bold",
                    name: "schoolId",
                    modelValue: _ctx.onlyId.schoolId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.onlyId.schoolId) = $event)),
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getListSekolah())),
                    disabled: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.listSekolah, (option) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: option._id,
                          label: option.name,
                          value: option._id
                        }, null, 8, _hoisted_10))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "kelas",
                    disabled: "",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Kelas",
                    modelValue: _ctx.editSiswa.kelas,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editSiswa.kelas) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.editSiswa.kelas == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.items.errorkelas), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_15))
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "kelasDetail",
                    disabled: "",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Kelas Detail",
                    modelValue: _ctx.editSiswa.kelasDetail,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editSiswa.kelasDetail) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.editSiswa.kelasDetail == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.items.errorkelasDetail), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_21))
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode(_component_Field, {
                    type: "number",
                    name: "identityNumber",
                    disabled: "",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Nomor Identitas",
                    modelValue: _ctx.editSiswa.identityNumber,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editSiswa.identityNumber) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.editSiswa.identityNumber == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.items.erroridentityNumber), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_26))
                ])
              ]),
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "name",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Nama",
                    disabled: "",
                    modelValue: _ctx.editSiswa.name,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editSiswa.name) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.editSiswa.name == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.items.errorname), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_33))
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createVNode(_component_Field, {
                    as: "select",
                    class: "form-select form-select-lg fw-bold",
                    name: "gender",
                    placeholder: "Isi Jenis Kelamin",
                    autocomplete: "off",
                    disabled: "",
                    modelValue: _ctx.editSiswa.gender,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editSiswa.gender) = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_36,
                      _hoisted_37,
                      _hoisted_38
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.editSiswa.gender == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.items.errorgender), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_41))
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createVNode(_component_Field, {
                    type: "date",
                    name: "dateOfBirth",
                    disabled: "",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Tanggal Lahir",
                    modelValue: _ctx.editSiswa.dateOfBirth,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editSiswa.dateOfBirth) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.editSiswa.dateOfBirth == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.items.errordateOfBirth), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_47))
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _hoisted_49,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "placeOfBirth",
                    disabled: "",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Tempat Lahir",
                    modelValue: _ctx.editSiswa.placeOfBirth,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editSiswa.placeOfBirth) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.editSiswa.placeOfBirth == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.items.errorplaceOfBirth), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_52))
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _hoisted_55,
                  _createVNode(_component_Multiselect, {
                    name: "province",
                    modelValue: _ctx.editSiswa.address.province,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editSiswa.address.province) = $event)),
                    placeholder: "Pilih Provinsi",
                    mode: "single",
                    disabled: "",
                    "create-option": false,
                    options: _ctx.items.provinsiOptions,
                    searchable: true,
                    label: "name",
                    "track-by": "name",
                    "value-prop": "name",
                    onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.pilihProv($event)))
                  }, null, 8, ["modelValue", "options"]),
                  (
                  _ctx.editSiswa.address.province == '' ||
                  _ctx.editSiswa.address.province == null
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.items.errorprovince), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_58))
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _hoisted_60,
                  _createVNode(_component_Multiselect, {
                    name: "city",
                    modelValue: _ctx.editSiswa.address.city,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.editSiswa.address.city) = $event)),
                    placeholder: "Pilih Kota/Kabupaten",
                    mode: "single",
                    disabled: "",
                    "create-option": false,
                    options: _ctx.items.kabupatenOptions,
                    searchable: true,
                    label: "name",
                    "track-by": "name",
                    "value-prop": "name",
                    onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.pilihKab($event)))
                  }, null, 8, ["modelValue", "options"]),
                  (
                  _ctx.editSiswa.address.city == '' || _ctx.editSiswa.address.city == null
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.items.errorcity), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_63))
                ])
              ]),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _hoisted_66,
                  _createVNode(_component_Multiselect, {
                    name: "regency",
                    modelValue: _ctx.editSiswa.address.regency,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editSiswa.address.regency) = $event)),
                    placeholder: "Pilih Kecamatan",
                    mode: "single",
                    disabled: "",
                    "create-option": false,
                    options: _ctx.items.kecamatanOptions,
                    searchable: true,
                    label: "name",
                    "track-by": "name",
                    "value-prop": "name",
                    onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.pilihKec($event)))
                  }, null, 8, ["modelValue", "options"]),
                  (
                  _ctx.editSiswa.address.regency == '' ||
                  _ctx.editSiswa.address.regency == null
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.items.errorregency), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_69))
                ]),
                _createElementVNode("div", _hoisted_70, [
                  _hoisted_71,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "detail",
                    disabled: "",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Alamat",
                    modelValue: _ctx.editSiswa.address.detail,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.editSiswa.address.detail) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.editSiswa.address.detail == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                        _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.items.errordetail), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_74))
                ])
              ]),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _hoisted_77,
                  _createVNode(_component_el_form_item, { prop: "tags" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.editSiswa.tags,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.editSiswa.tags) = $event)),
                        class: "form-control",
                        multiple: "",
                        filterable: "",
                        "allow-create": "",
                        disabled: "",
                        "default-first-option": "",
                        placeholder: "Isi Tags",
                        "allow-duplicates": "false"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, [
                      _createVNode(_component_ErrorMessage, { name: "tags" })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("button", {
                class: "btn btn-danger me-3",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$router.push('/superadmin/siswa')))
              }, " Kembali ")
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}